/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_General_SectionInputs */

const vi_grower_general_section = /** @type {(inputs: Grower_General_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin chung`)
};

/**

* @param {Grower_General_SectionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_general_section = /** @type {((inputs?: Grower_General_SectionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_General_SectionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_general_section(inputs)
});